import { render, staticRenderFns } from "./ProductGroupAdd.vue?vue&type=template&id=a80023a6&scoped=true&"
import script from "./ProductGroupAdd.vue?vue&type=script&lang=js&"
export * from "./ProductGroupAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroupAdd.vue?vue&type=style&index=0&id=a80023a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80023a6",
  null
  
)

export default component.exports